// import { useEffect } from "react";

// let numbers: number[] = [];
export const useRandomSegmentGenerator = (
  n: number,
  repeat: boolean = false,
  numbers: number[],
) => {
  const reset = () => {
    const numArray: number[] = Array.from({ length: n + 1 }, (_, i) => i);
    shuffle(numArray);
    numbers = numArray;
  };

  const shuffle = (array: number[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  };

  const getNext = (): { next: number; numbers: number[] } => {
    if (numbers.length === 0) {
      reset();
    }
    if (repeat) {
      return {
        next: numbers[Math.floor(Math.random() * numbers.length)],
        numbers: numbers,
      };
    } else {
      return {
        next: numbers.pop()!,
        numbers: numbers,
      };
    }
  };

  return { getNext, reset };
};
